import { useEffect, useMemo, useState } from "react";
import useFetch from "./useFetch";
import { useDispatch } from "../store/useStore";

type ColorData = {
  color: string;
  country: string;
};

const useColor = (baseUrl: string, env?: string) => {
  const [open, setOpen] = useState(false);

  const { get } = useFetch(baseUrl);

  const { dispatch } = useDispatch();

  const [colorState, setColorState] = useState<ColorData>();

  const getIpState = async () => {
    return get<{ data: ColorData }>(`uapi/v1/cms/color`) as Promise<any>;
  };

  const getState = async () => {
    try {
      const res = await getIpState();
      setColorState(res.data);
      if (res.data.color === "YELLOW") {
        setOpen(true);
      }
      if (res.code === 200) {
        dispatch({
          type: "SET_COUNTRY",
          payload: res.data.country
        });
      }
      if (res.data.color === "GREEN") {
        sessionStorage.setItem("ipFlag", JSON.stringify(false));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isUk = useMemo(() => {
    return colorState?.country.toLocaleUpperCase() === "GB" ? true : false;
  }, [colorState]);

  useEffect(() => {
    const ipFlag = sessionStorage.getItem("ipFlag");
    if (ipFlag && JSON.parse(ipFlag)) {
      setOpen(false);
    } else {
      if (env === "client") {
        getState();
      }
    }
  }, [env]);

  return {
    open,
    setOpen,
    colorState,
    isUk
  };
};

export default useColor;
